import { MainContainer } from 'components/page/containers/MainContainer'
import React from 'react'
import { observer } from 'mobx-react'
import { AccountSettingsSideNav } from './AccountSettingsSideNav'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'

const AccountSettingsMobilePage = () => {
    const {backendUser} = useAuth()
    const {
        inviteUsersByEmail
      } = useOnboarding()
  return (
    <MainContainer
      inviteUsersByEmail={inviteUsersByEmail}
      stickTopBar
      title={`Welcome ${backendUser?.firstName} ${backendUser?.lastName}`}
      user={backendUser}
      showAvatar
    >
      <AccountSettingsSideNav />
    </MainContainer>
  )
}

export default observer(AccountSettingsMobilePage)
